'use client';

import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '@/shared/utils/cn';

export const FieldError = forwardRef<HTMLParagraphElement, ComponentPropsWithoutRef<'p'>>(
  ({ className, children, ...props }, ref) => (
    <p ref={ref} className={cn('text-error text-sm', className)} {...props}>
      {children}
    </p>
  ),
);
FieldError.displayName = 'FieldError';
